import PersonalEmployeeAwayEntitlementList from "@/modules/personal/stores/away/entitlement/personal_employee_away_entitlement_list";
import PersonalEmployeeAwayManageApplication from "@/modules/personal/stores/away/application/personal_away_manage_application";

export default {
  modules: {
    PersonalEmployeeAwayEntitlementList,
    PersonalEmployeeAwayManageApplication,
  },
};
